import { render, staticRenderFns } from "./EventPriceBanner.vue?vue&type=template&id=2813f84e&scoped=true"
import script from "./EventPriceBanner.vue?vue&type=script&lang=js"
export * from "./EventPriceBanner.vue?vue&type=script&lang=js"
import style0 from "./EventPriceBanner.vue?vue&type=style&index=0&id=2813f84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813f84e",
  null
  
)

export default component.exports